module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editSpecialNews"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("商业专题")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("编辑新闻")])], 1), _vm._v(" "), _c('div', {
    staticClass: "edit-special-news-box"
  }, [_c('div', {
    staticClass: "special-list-box"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入关键字进行过滤"
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  }), _vm._v(" "), _c('el-tree', {
    ref: "specialTree",
    staticClass: "tree",
    attrs: {
      "data": _vm.specialList,
      "props": _vm.propsRules,
      "filter-node-method": _vm.filterNode,
      "highlight-current": true
    },
    on: {
      "node-click": _vm.selectSpecial
    }
  })], 1), _vm._v(" "), (_vm.newsList) ? _c('div', {
    staticClass: "news-contents-box"
  }, [_c('div', {
    staticClass: "refresh-btn-box",
    on: {
      "click": _vm.refreshNews
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/refresh.png"),
      "alt": "刷新"
    }
  })]), _vm._v(" "), (_vm.newsList[0].newsTypeName === '头图') ? _c('div', {
    staticClass: "head-image-box"
  }, [_c('HeadImgComponent', {
    attrs: {
      "newsData": _vm.headImg,
      "isAd": _vm.newsList[0].isAd === 1,
      "showControl": true
    }
  }), _vm._v(" "), (_vm.showControl) ? _c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "edit",
      "size": "mini"
    },
    on: {
      "click": _vm.editHeadImg
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "delete",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.deleteNews(_vm.newsList[0].newsContentId)
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.currentSpecial.isShowDes) ? _c('div', {
    staticClass: "special-desc-box"
  }, [_c('div', {
    staticClass: "desc-icon"
  }, [_vm._v("概述")]), _vm._v(" "), _c('span', {
    staticClass: "desc-content"
  }, [_vm._v(_vm._s(_vm.currentSpecial.specialContent))])]) : _vm._e(), _vm._v(" "), (_vm.newsList && _vm.newsList.length > 0) ? _c('div', {
    staticClass: "news-list-box"
  }, [_vm._l((_vm.newsList), function(newsItem, index) {
    return [(newsItem.newsTypeName === '无图新闻') ? _c('div', {
      staticClass: "news-item-box"
    }, [_c('TextComponent', {
      attrs: {
        "newsData": newsItem,
        "isAd": newsItem.isAd === 1,
        "showControl": true
      }
    }), _vm._v(" "), (_vm.showControl) ? _c('el-button-group', [(_vm.newsList[0].newsTypeName === '头图' ? index > 1 : index > 0) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.moveUp(index)
        }
      }
    }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (index < _vm.newsList.length - 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.moveDown(index)
        }
      }
    }, [_vm._v("下移")]) : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "edit",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.editNews(newsItem)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "delete",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.deleteNews(newsItem.newsContentId)
        }
      }
    })], 1) : _vm._e()], 1) : (newsItem.newsTypeName === '单图新闻') ? _c('div', {
      staticClass: "news-item-box"
    }, [_c('OneImgComponent', {
      attrs: {
        "newsData": newsItem,
        "isAd": newsItem.isAd === 1,
        "showControl": true
      }
    }), _vm._v(" "), (_vm.showControl) ? _c('el-button-group', [(_vm.newsList[0].newsTypeName === '头图' ? index > 1 : index > 0) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.moveUp(index)
        }
      }
    }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (index < _vm.newsList.length - 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.moveDown(index)
        }
      }
    }, [_vm._v("下移")]) : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "edit",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.editNews(newsItem)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "delete",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.deleteNews(newsItem.newsContentId)
        }
      }
    })], 1) : _vm._e()], 1) : (newsItem.newsTypeName === '大图新闻') ? _c('div', {
      staticClass: "news-item-box"
    }, [_c('BigImgComponent', {
      attrs: {
        "newsData": newsItem,
        "isAd": newsItem.isAd === 1,
        "showControl": true
      }
    }), _vm._v(" "), (_vm.showControl) ? _c('el-button-group', [(_vm.newsList[0].newsTypeName === '头图' ? index > 1 : index > 0) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.moveUp(index)
        }
      }
    }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (index < _vm.newsList.length - 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.moveDown(index)
        }
      }
    }, [_vm._v("下移")]) : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "edit",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.editNews(newsItem)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "delete",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.deleteNews(newsItem.newsContentId)
        }
      }
    })], 1) : _vm._e()], 1) : (newsItem.newsTypeName === '多图新闻') ? _c('div', {
      staticClass: "news-item-box"
    }, [_c('ThreeImgComponent', {
      attrs: {
        "newsData": newsItem,
        "isAd": newsItem.isAd === 1,
        "showControl": true
      }
    }), _vm._v(" "), (_vm.showControl) ? _c('el-button-group', [(_vm.newsList[0].newsTypeName === '头图' ? index > 1 : index > 0) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.moveUp(index)
        }
      }
    }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (index < _vm.newsList.length - 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.moveDown(index)
        }
      }
    }, [_vm._v("下移")]) : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "edit",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.editNews(newsItem)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "delete",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.deleteNews(newsItem.newsContentId)
        }
      }
    })], 1) : _vm._e()], 1) : (newsItem.newsTypeName === '视频新闻') ? _c('div', {
      staticClass: "news-item-box"
    }, [_c('VideoComponent', {
      attrs: {
        "newsData": newsItem,
        "isAd": newsItem.isAd === 1,
        "showControl": true
      }
    }), _vm._v(" "), (_vm.showControl) ? _c('el-button-group', [(_vm.newsList[0].newsTypeName === '头图' ? index > 1 : index > 0) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.moveUp(index)
        }
      }
    }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (index < _vm.newsList.length - 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.moveDown(index)
        }
      }
    }, [_vm._v("下移")]) : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "edit",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.editNews(newsItem)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "delete",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.deleteNews(newsItem.newsContentId)
        }
      }
    })], 1) : _vm._e()], 1) : (newsItem.newsTypeName === '图集') ? _c('div', {
      staticClass: "news-item-box"
    }, [_c('ImgListComponent', {
      attrs: {
        "newsData": newsItem,
        "isAd": newsItem.isAd === 1,
        "showControl": true
      }
    }), _vm._v(" "), (_vm.showControl) ? _c('el-button-group', [(_vm.newsList[0].newsTypeName === '头图' ? index > 1 : index > 0) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.moveUp(index)
        }
      }
    }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (index < _vm.newsList.length - 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.moveDown(index)
        }
      }
    }, [_vm._v("下移")]) : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "edit",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.editNews(newsItem)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "delete",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.deleteNews(newsItem.newsContentId)
        }
      }
    })], 1) : _vm._e()], 1) : _vm._e()]
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑新闻",
      "lock-scroll": true
    },
    on: {
      "close": _vm.closeEditNewsDialog
    },
    model: {
      value: (_vm.config.editNewsDialog.visible),
      callback: function($$v) {
        _vm.config.editNewsDialog.visible = $$v
      },
      expression: "config.editNewsDialog.visible"
    }
  }, [(_vm.config.editNewsDialog.newsTypeName === '无图新闻') ? _c('el-form', {
    ref: "textNews",
    attrs: {
      "model": _vm.config.editNewsDialog.newsItem
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "newsContentTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentTitle),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentTitle = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "来源",
      "prop": "newsContentSource"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentSource),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentSource = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentSource"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "置顶权重",
      "prop": "newsContentIsTop"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentIsTop),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentIsTop = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentIsTop"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "落地链接",
      "prop": "newsContentURL"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentURL),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentURL = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentURL"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.editNewsDialog.newsTypeName === '单图新闻') ? _c('el-form', {
    ref: "oneImgNews",
    attrs: {
      "model": _vm.config.editNewsDialog.newsItem
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "newsContentTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentTitle),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentTitle = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "来源",
      "prop": "newsContentSource"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentSource),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentSource = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentSource"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "置顶权重",
      "prop": "newsContentIsTop"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentIsTop),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentIsTop = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentIsTop"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "落地链接",
      "prop": "newsContentURL"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentURL),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentURL = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentURL"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片链接",
      "prop": "newsContentImage"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentImage),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentImage = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentImage"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.editNewsDialog.newsTypeName === '大图新闻') ? _c('el-form', {
    ref: "bigImgNews",
    attrs: {
      "model": _vm.config.editNewsDialog.newsItem
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "newsContentTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentTitle),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentTitle = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "来源",
      "prop": "newsContentSource"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentSource),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentSource = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentSource"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "置顶权重",
      "prop": "newsContentIsTop"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentIsTop),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentIsTop = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentIsTop"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "落地链接",
      "prop": "newsContentURL"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentURL),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentURL = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentURL"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片链接",
      "prop": "newsContentImage"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentImage),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentImage = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentImage"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.editNewsDialog.newsTypeName === '多图新闻') ? _c('el-form', {
    ref: "threeImgNews",
    attrs: {
      "model": _vm.config.editNewsDialog.newsItem
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "newsContentTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentTitle),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentTitle = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "来源",
      "prop": "newsContentSource"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentSource),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentSource = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentSource"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "置顶权重",
      "prop": "newsContentIsTop"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentIsTop),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentIsTop = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentIsTop"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "落地链接",
      "prop": "newsContentURL"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentURL),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentURL = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentURL"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.config.editNewsDialog.newsItem.newsContentImage), function(imageItem, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": '图片链接' + (index + 1),
        "prop": "newsContentImage"
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off"
      },
      model: {
        value: (_vm.config.editNewsDialog.newsItem.newsContentImage[index]),
        callback: function($$v) {
          var $$exp = _vm.config.editNewsDialog.newsItem.newsContentImage,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.config.editNewsDialog.newsItem.newsContentImage[index] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "config.editNewsDialog.newsItem.newsContentImage[index]"
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.config.editNewsDialog.newsTypeName === '图集') ? _c('el-form', {
    ref: "imgListNews",
    attrs: {
      "model": _vm.config.editNewsDialog.newsItem
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "来源",
      "prop": "newsContentSource"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentSource),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentSource = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentSource"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "置顶权重",
      "prop": "newsContentIsTop"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentIsTop),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentIsTop = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentIsTop"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.config.editNewsDialog.newsItem.newsContentImage), function(imageItem, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": '图片链接' + (index + 1),
        "prop": "newsContentImage"
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off"
      },
      model: {
        value: (_vm.config.editNewsDialog.newsItem.newsContentImage[index]),
        callback: function($$v) {
          var $$exp = _vm.config.editNewsDialog.newsItem.newsContentImage,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.config.editNewsDialog.newsItem.newsContentImage[index] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "config.editNewsDialog.newsItem.newsContentImage[index]"
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.config.editNewsDialog.newsTypeName === '视频新闻') ? _c('el-form', {
    ref: "videoNews",
    attrs: {
      "model": _vm.config.editNewsDialog.newsItem
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "newsContentTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentTitle),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentTitle = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "来源",
      "prop": "newsContentSource"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentSource),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentSource = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentSource"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "置顶权重",
      "prop": "newsContentIsTop"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentIsTop),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentIsTop = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentIsTop"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频链接",
      "prop": "newsContentURL"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentURL),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentURL = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentURL"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封皮图片链接",
      "prop": "newsContentImage"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.config.editNewsDialog.newsItem.newsContentImage),
      callback: function($$v) {
        _vm.config.editNewsDialog.newsItem.newsContentImage = $$v
      },
      expression: "config.editNewsDialog.newsItem.newsContentImage"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.editNewsDialog.newsTypeName === '头图') ? _c('el-form', {
    ref: "headImg"
  }, [_vm._l((_vm.headImg), function(imageItem, index) {
    return [_c('el-card', {
      staticClass: "box-card"
    }, [_c('el-form-item', {
      attrs: {
        "label": "图片链接",
        "prop": "image"
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off"
      },
      model: {
        value: (_vm.headImg[index].image),
        callback: function($$v) {
          _vm.headImg[index].image = $$v
        },
        expression: "headImg[index].image"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "落地链接",
        "prop": "link"
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off"
      },
      model: {
        value: (_vm.headImg[index].link),
        callback: function($$v) {
          _vm.headImg[index].link = $$v
        },
        expression: "headImg[index].link"
      }
    })], 1)], 1)]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [(_vm.config.editNewsDialog.newsTypeName === '头图' && _vm.headImg.length > 1) ? _c('el-button', {
    on: {
      "click": _vm.deleteHeadImgCard
    }
  }, [_vm._v("删除卡片")]) : _vm._e(), _vm._v(" "), (_vm.config.editNewsDialog.newsTypeName === '头图') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addHeadImgCard
    }
  }, [_vm._v("增加卡片")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeEditNewsDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitEditData
    }
  }, [_vm._v("确 定")])], 1)], 1)], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currentSpecial) ? _c('div', {
    staticClass: "add-news-box"
  }, [_c('div', {
    staticClass: "select-template-box"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("项目和组件")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('el-form', {
    ref: "newsTemplate",
    attrs: {
      "model": _vm.newsTemplate,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择组件"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择组件"
    },
    on: {
      "change": _vm.changeTempate
    },
    model: {
      value: (_vm.newsTemplate.current),
      callback: function($$v) {
        _vm.newsTemplate.current = $$v
      },
      expression: "newsTemplate.current"
    }
  }, _vm._l((_vm.newsTemplate.list), function(newsTemplateItem) {
    return _c('el-option', {
      key: newsTemplateItem.newsTypeId,
      attrs: {
        "label": newsTemplateItem.newsTypeName,
        "value": newsTemplateItem
      }
    })
  }))], 1)], 1)], 1)]), _vm._v(" "), (_vm.newsTemplate.current) ? _c('div', {
    staticClass: "add-news-content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("新闻内容")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(_vm.newsTemplate.current.newsTypeName === '大图新闻') ? _c('BigImgAddNewsComponent', {
    attrs: {
      "specialId": _vm.currentSpecial.specialId,
      "newsTypeId": _vm.newsTemplate.current.newsTypeId,
      "refreshNews": _vm.refreshNews
    }
  }) : (_vm.newsTemplate.current.newsTypeName === '单图新闻') ? _c('OneImgAddNewsComponent', {
    attrs: {
      "specialId": _vm.currentSpecial.specialId,
      "newsTypeId": _vm.newsTemplate.current.newsTypeId,
      "refreshNews": _vm.refreshNews
    }
  }) : (_vm.newsTemplate.current.newsTypeName === '无图新闻') ? _c('TextAddNewsComponent', {
    attrs: {
      "specialId": _vm.currentSpecial.specialId,
      "newsTypeId": _vm.newsTemplate.current.newsTypeId,
      "refreshNews": _vm.refreshNews
    }
  }) : (_vm.newsTemplate.current.newsTypeName === '多图新闻') ? _c('ThreeImgAddNewsComponent', {
    attrs: {
      "specialId": _vm.currentSpecial.specialId,
      "newsTypeId": _vm.newsTemplate.current.newsTypeId,
      "refreshNews": _vm.refreshNews
    }
  }) : (_vm.newsTemplate.current.newsTypeName === '视频新闻') ? _c('VideoAddNewsComponent', {
    attrs: {
      "specialId": _vm.currentSpecial.specialId,
      "newsTypeId": _vm.newsTemplate.current.newsTypeId,
      "refreshNews": _vm.refreshNews
    }
  }) : (_vm.newsTemplate.current.newsTypeName === '图集') ? _c('ImgListAddNewsComponent', {
    attrs: {
      "specialId": _vm.currentSpecial.specialId,
      "newsTypeId": _vm.newsTemplate.current.newsTypeId,
      "refreshNews": _vm.refreshNews
    }
  }) : (_vm.newsTemplate.current.newsTypeName === '头图') ? _c('HeadImgAddNewsComponent', {
    attrs: {
      "specialId": _vm.currentSpecial.specialId,
      "newsTypeId": _vm.newsTemplate.current.newsTypeId,
      "refreshNews": _vm.refreshNews
    }
  }) : _vm._e()], 1)]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-746ffbb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/business/Edit.vue
// module id = 779
// module chunks = 1